import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { FocusLock } from '@bingads-webui-react/focus-lock';
import { Scenario, Activity } from '@bingads-webui-react/hoc-with-signal';
import { RequestCallForm } from './request-call-form';

export class RequestCallModal extends React.Component {
  static defaultProps = {
    isOpen: true,
    featureName: '',
    onClose() {},
    portalClassName: undefined,
    permissions: {},
    resourcePath: undefined,
    logger: undefined,
    context: undefined,
  };
  static propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    i18n: PropTypes.shape({
      getString: PropTypes.func,
      getCldr: PropTypes.func,
    }).isRequired,
    featureName: PropTypes.string,
    portalClassName: PropTypes.string,
    permissions: PropTypes.shape({}),
    resourcePath: PropTypes.string,
    logger: PropTypes.shape({
      trace: PropTypes.func,
      error: PropTypes.func,
    }),
    context: PropTypes.shape({}),
  };

  constructor(props) {
    super(props);
    Modal.setAppElement(document.body);
  }

  render() {
    const modalStyle = {
      overlay: {
        zIndex: 2000,
        backgroundColor: 'rgba(51,51,51,0.5)',
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        border: '1px solid #d9d9d9',
        borderRadius: '0px',
        transform: 'translate(-50%, -50%)',
        marginRight: '-50%',
        minWidth: '300px',
      },
    };

    return (
      <Scenario name="Request-call-modal">
        <Activity name="Request-call-modal">
          <Modal
            isOpen={this.props.isOpen}
            style={modalStyle}
            portalClassName={this.props.portalClassName}
            ariaHideApp={false}
            aria={{
              labelledby: 'msSupportRequestCallFormTitle',
              modal: 'true',
            }}
          >
            <FocusLock
              onExit={this.props.onClose}
              lockRegionAriaLabel={this.props.i18n.getString('RequestCallModal_DialogReadyLabel')}
              focusFirstItemOnMount
            >
              <RequestCallForm
                i18n={this.props.i18n}
                onSuccess={this.props.onClose}
                onCancel={this.props.onClose}
                featureName={this.props.featureName}
                context={this.props.context}
                permissions={this.props.permissions}
                resourcePath={this.props.resourcePath}
                logger={this.props.logger}
              />
            </FocusLock>
          </Modal>
        </Activity>
      </Scenario>
    );
  }
}
